import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const EmailAttachment_ = z.object({
  Content: z.string(),
  Name: z.string(),
  ContentType: z.string(),
  ContentID: z.string(),
});
export const EmailAttachment = EmailAttachment_;
export type EmailAttachment = z.infer<typeof EmailAttachment_>;

const Email_ = z.object({
  attachments: z.array(EmailAttachment),
  id: z.string(),
  html: z.string(),
  subject: z.string(),
  ampHtml: z.string().optional(),
  headers: z.record(z.string(), z.string()).optional(),
});
export const Email = Email_;
export type Email = z.infer<typeof Email_>;

const PostmarkEmail_ = z.object({
  attachments: z.array(z.any()),
  subject: z.string().optional(),
  templateId: z.string(),
  variables: z.record(z.string(), z.any()),
});
export const PostmarkEmail: z.ZodType<PostmarkEmail> = PostmarkEmail_;
export interface PostmarkEmail extends z.infer<typeof PostmarkEmail_> {}

const Recipient_ = z.object({ name: z.string(), email: z.string() });
export const Recipient: z.ZodType<Recipient> = Recipient_;
export interface Recipient extends z.infer<typeof Recipient_> {}

const TO_ = z.object({ recipients: z.array(Recipient) });
export const TO: z.ZodType<TO> = TO_;
export interface TO extends z.infer<typeof TO_> {}

const SESTag_ = z.object({ Name: z.string(), Value: z.string() });
export const SESTag = SESTag_;
export type SESTag = z.infer<typeof SESTag_>;

const FromAddress_ = z.object({
  name: z.string().optional(),
  email: z.string().optional(),
});
export const FromAddress = FromAddress_;
export type FromAddress = z.infer<typeof FromAddress_>;

const SendEmailProps_ = z.object({
  to: TO,
  replyTo: TO.nullable().optional(),
  from: FromAddress.optional(),
  cc: TO.nullable().optional(),
  email: z.union([Email, PostmarkEmail]),
  provider: createEnum(["postmark", "ses", "sendgrid"]).optional(),
  sesTags: z.array(SESTag).optional(),
  sesConfigurationSet: z.string().optional(),
  bcc: TO.nullable().optional(),
});
export const SendEmailProps = SendEmailProps_;
export type SendEmailProps = z.infer<typeof SendEmailProps_>;
